export interface EffectiveCohortMaxInput {
  /** Cap stored on the live record (BE-echoed when SCRUM-28 ships). */
  liveCap: number | null | undefined;
  /** Global BE cap (currently 4). Acts as upper safety bound. */
  beCap: number;
  /** Master-only FE fallback from storage.getLocalCohortMax. Null on guest devices. */
  fallback: number | null;
}

/**
 * Resolves the effective per-live cohost cap. Returns null when the live
 * is solo (no caps anywhere). Otherwise: live-record cap if present, else
 * FE fallback, clamped to [1, beCap].
 *
 * NOTE: Until BE follow-up SCRUM-28 ships, `liveCap` is null on guest
 * devices. They will see `null` here and the capacity blocker will not
 * fire — this is acknowledged in the spec §3.5.
 */
export function effectiveCohortMax({
  liveCap,
  beCap,
  fallback,
}: EffectiveCohortMaxInput): number | null {
  const candidate = liveCap ?? fallback;
  if (candidate == null) return null;
  return Math.max(1, Math.min(beCap, Math.floor(candidate)));
}
